import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Position } from "../models/position";
import { Area } from "../models/area";
import { Division } from "../models/division";
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CatalogService {

  constructor(private http: HttpClient) { }

  private apiUrl = `${environment.apiUrl}`;
  private url: string = this.apiUrl + 'api/catalog'; 

  /*findCompaniesCatalog(): Observable<any> {
    return this.http.get<any[]>(`${this.url}/companies`);
  }*/

  findDivisionsCatalog(): Observable<any> {
    return this.http.get<any[]>(`${this.url}/divisions`);
  }

  findAreasCatalog(): Observable<any> {
    return this.http.get<any[]>(`${this.url}/areas`);
  }

  findBenefitTypeCatalog(): Observable<any> {
    return this.http.get<any[]>(`${this.url}/benefitTypes`);
  }

  findBenefitsCatalog(): Observable<any> {
    return this.http.get<any[]>(`${this.url}/benefitsCatalog`);
  }

  findSignatureTypeCatalog(): Observable<any> {
    return this.http.get<any[]>(`${this.url}/signatureTypes`);
  }

  findUsersWithRolAutCatalog(): Observable<any> {
    return this.http.get<any[]>(`${this.url}/usersWithRolAutCatalog`);
  }
  
  findSignatureGroupsCatalog(): Observable<any> {
    return this.http.get<any[]>(`${this.url}/signatureGroupsCatalog`);
  }
  
  findBenefitGroupsCatalogAct(): Observable<any> {
    return this.http.get<any[]>(`${this.url}/benefitGroupsCatalog`);
  }
  
  findHolidayGroupsCatalogAct(): Observable<any> {
    return this.http.get<any[]>(`${this.url}/holidayGroupsCatalog`);
  }

  findWithholdingsCatalog(): Observable<any> {
    return this.http.get<any[]>(`${this.url}/withholdingsCatalog`);
  }

  findWithholdingTypeCatalog(): Observable<any> {
    return this.http.get<any[]>(`${this.url}/withholdingTypes`);
  }
  
  findCostsPerEmployeesCatalog(): Observable<any> {
    return this.http.get<any[]>(`${this.url}/costsPerEmployeesCatalog`);
  }
  
  findCostsPerEmployeeTypeCatalog(): Observable<any> {
    return this.http.get<any[]>(`${this.url}/costsPerEmployeeTypes`);
  }

  findVariablesCatalog(): Observable<any> {
    return this.http.get<any[]>(`${this.url}/variablesCatalog`);
  }

  findObjectsCatalog(): Observable<any> {
    return this.http.get<any[]>(`${this.url}/objectsCatalog`);
  }
  
  findWithholdingGroupsCatalog(): Observable<any> {
    return this.http.get<any[]>(`${this.url}/withholdingGroupsCatalog`);
  }
  
  findFormulaGroupsCatalog(): Observable<any> {
    return this.http.get<any[]>(`${this.url}/formulaGroupsCatalog`);
  }
  
  findHCostsPerEmployeeGroupsCatalog(): Observable<any> {
    return this.http.get<any[]>(`${this.url}/costsPerEmployeeGroupsCatalog`);
  }
}

